import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './Pages/Login/Login';
import Cases from './Pages/Cases/Cases';
import Leads from './Pages/Leads/Leads';
import Opportunities from './Pages/Opportunities/Opportunities';
import Contacts from './Pages/Contacts/Contacts';
import Accounts from './Pages/Accounts/Accounts';
import Dashboard from './Pages/Dashboard/Dashboard';
import LeadDetail from './Pages/LeadDetail/LeadDetail';
import OpportunityDetail from './Pages/OpportunityDetail/OpportunityDetail';
import CaseDetail from './Pages/CaseDetail/CaseDetail';
import CreateCase from './Pages/CreateCase/CreateCase';
import Search from './Pages/Search/Search';
import ContactDetail from './Pages/ContactDetail/ContactDetail';
import AccountDetail from './Pages/AccountDetail/AccountDetail';
import NewDataResult from './Pages/NewDataResult/NewDataResult';


function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <Routes>
        {/* Page routing start */}
      <Route path="/" exact element={<Login />} />
      <Route path="/Cases/:searchedKeyword?" exact element={<Cases />} />
      <Route path="/Leads/:searchedKeyword?" exact element={<Leads />} />
      <Route path="/Opportunities/:searchedKeyword?" exact element={<Opportunities />} />
      <Route path="/Contacts/:searchedKeyword?" exact element={<Contacts />} />
      <Route path="/Accounts/:searchedKeyword?" exact element={<Accounts />} />
      <Route path="/Dashboard" exact element={<Dashboard />} />
      <Route path="/LeadDetail/:id" exact element={<LeadDetail />} />
      <Route path="/OpportunityDetail/:id" exact element={<OpportunityDetail />} />
      <Route path="/CaseDetail/:id" exact element={<CaseDetail />} />
      <Route path="/CreateCase" exact element={<CreateCase />} />
      <Route path="/Search/:searchedKeyword" exact element={<Search />} />
      <Route path="/NewDataResult/:obj/:id/:msg/:msg2" exact element={<NewDataResult />} />
      <Route path="/ContactDetail/:id" exact element={<ContactDetail />} />
      <Route path="/AccountDetail/:id" exact element={<AccountDetail />} />
      {/* Page routing end */}
      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
